import { TOUR_TRANSLATIONS } from "../translations"

export const getDynamicAssortmentSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="dynamic-assortment-filters"]',
            title: t.dynamicAssortmentFilters.title,
            content: t.dynamicAssortmentFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="dynamic-assortment-table"]',
            title: t.dynamicAssortmentTable.title,
            content: t.dynamicAssortmentTable.content,
        },
    ]
}
